/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { NotaryAPI } from '../api/notary/types';
import { useRootSelector } from './useRootSelector';

export const usePermissions = (): NotaryAPI.BSRPermissions[] => {
  return useRootSelector(state => state.user?.permissions || []);
};
